<template>
  <div id="esim_model">
    <!-- <h5>不確定?</h5> -->
    <p><b>以手機撥打<a href="tel:*#06#">*#06#</a>，如有出現 EID 的字樣，表示你的手機支援eSIM！</b></p>
    <b-img class="imgScale mb-5" fluid src="https://www.esim4travel.com/assets/img/picture/installation/check_android_dvc_esim.jpg"></b-img>
    <div class="smtxt subtxt mb-3">以下為 2023/8 更新，可能有更多裝置支援 eSIM。
      中國大陸銷售的 iPhone 不支援 eSIM。實際情形請與電信業者確認或用手機撥打*#06#確認。
      <!-- 鎖卡機、中港澳購買的手機，不支援eSIM功能。 -->
    </div>
    <h5>Apple iPhone</h5>
    <ul>
      <li>iPhone 14 系列</li>
      <li>iPhone 13 系列</li>
      <li>iPhone 12 系列</li>
      <li>iPhone 11 系列</li>
      <li>iPhone XR/XS/XS Max</li>
      <li>iPhone SE2/SE3</li>
    </ul>

    <h5>Apple iPad</h5>
    <ul>
      <li>iPad Air (第3代以上)</li>
      <li>iPad Pro (第3代以上)</li>
      <li>iPad Mini (第5代以上)</li>
    </ul>

    <h5>Google Pixel</h5>
    <ul>
      <li>Pixel 4/4a/4XL</li>
      <li>Pixel 5/5a</li>
      <li>Pixel 6/6a/ Pro</li>
      <li>Pixel 7/7a/ Pro</li>
    </ul>
  </div>
</template>

<script>
export default {
  // props: {
  //   breadItems: {
  //     required: true
  //   }
  // }
}
</script>

<style lang="scss">
#esim_model {
  .container {
  }
}
</style>
